/* eslint-disable react-refresh/only-export-components -- this is the application entry point */

import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { FlagProvider, type IConfig } from "@unleash/proxy-client-react";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import "./styles.css";
import "./experience.css";

const unleashUrl = import.meta.env.VITE_UNLEASH_URL?.trim();
const unleashClientKey = import.meta.env.VITE_UNLEASH_CLIENT_KEY?.trim();
const unleashAppName =
  import.meta.env.VITE_UNLEASH_APP_NAME?.trim() || "petcollab-website";
const refreshIntervalValue = Number(
  import.meta.env.VITE_UNLEASH_REFRESH_INTERVAL_SECONDS,
);
const refreshInterval =
  Number.isFinite(refreshIntervalValue) && refreshIntervalValue > 0
    ? refreshIntervalValue
    : 900;

const remoteContentEnabled = Boolean(unleashUrl && unleashClientKey);
const unleashConfig: IConfig | undefined = remoteContentEnabled
  ? {
      appName: unleashAppName,
      clientKey: unleashClientKey,
      refreshInterval,
      url: unleashUrl,
    }
  : undefined;

function ContentProvider({ children }: { children: ReactNode }) {
  return unleashConfig ? (
    <FlagProvider config={unleashConfig}>{children}</FlagProvider>
  ) : (
    children
  );
}

const root = document.getElementById("root");

if (!root) {
  throw new Error("PetCollab could not find its application root.");
}

createRoot(root).render(
  <StrictMode>
    <ContentProvider>
      <BrowserRouter>
        <App remoteContentEnabled={remoteContentEnabled} />
      </BrowserRouter>
    </ContentProvider>
  </StrictMode>,
);
